/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SocialConnection = 'GOOGLE' | 'FACEBOOK' | 'APPLE';

export const SocialConnection = {
    Google: 'GOOGLE' as SocialConnection,
    Facebook: 'FACEBOOK' as SocialConnection,
    Apple: 'APPLE' as SocialConnection
};

